<img
  class="aligncenter big-asterisk"
  src="./../../assets/png/blue-asterisk.png" />
